import { type NetworkType } from '@capsicum/common';
import { Grid, SkeletonItem, Text } from '@capsicum/common-web';
import { type MyNft } from '@capsicum/socios-core';
import { NftCard, NftCardSkeleton } from '@capsicum/socios-core-web';
import styled from 'styled-components';

export type NftListProps = {
	nfts: Array<MyNft>;
	onClickNft: (nft: MyNft) => void;
	testID: string;
	title?: string;
};

export const NftListSkeleton = ({ withTitle = true }) => (
	<>
		{withTitle && <S.TitleSkeleton />}
		<Grid data-testid="nftList-skeleton">
			{[...Array(4)].map((_, i) => (
				<NftCardSkeleton key={`nftCardSkeleton-` + i} />
			))}
		</Grid>
	</>
);

export const NftList = ({ nfts, onClickNft, testID, title }: NftListProps) => (
	<>
		{title && (
			<S.Title color="main.subtle" data-testid={`${testID}-title`} variant="text5">
				{title}
			</S.Title>
		)}
		<Grid>
			{nfts.length > 0 &&
				nfts.map((nft: MyNft, i) => (
					<NftCard
						backgroundImageUrl={nft.partner?.rewardsBackground || ''}
						key={`nftCard-` + i}
						network={nft.blockchain?.networkType as NetworkType}
						nftImageUrl={nft.summary?.imageUrl || ''}
						subtitle={nft.summary?.description || ''}
						testID={`${testID}-${i}`}
						title={nft.summary?.name || ''}
						onActivate={() => onClickNft(nft)}
					/>
				))}
		</Grid>
	</>
);

namespace S {
	export const Title = styled(Text)`
		text-align: left;
		text-transform: uppercase;
		margin: ${({ theme }) => theme.spacings.xsmall} 0;
	`;

	export const TitleSkeleton = styled(SkeletonItem)`
		height: 14px;
		width: 100px;
		margin: ${({ theme }) => `${theme.spacings.xsmall} 0`};
	`;
}
